"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.PubSub = void 0;
var Providers_1 = require("../Providers");
Object.defineProperty(exports, "PubSub", { enumerable: true, get: function () { return Providers_1.MqttOverWS; } });
